import React from 'react';
import { Link } from 'react-router-dom';
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";
import logoLight from '../assets/images/logo-footer.webp';

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "SLAMMMM",
  "url": "https://www.slammmm.com/",
  "logo": "https://www.slammmm.com/assets/logo-BU_zE9SM.webp",
  "description": "Where Single Ladies And Men go to Meet, Mingle & Marry.",
  "sameAs": [
    "https://www.instagram.com/slammmm_com/",
    "https://www.facebook.com/p/Slammmmcom-100063651783076/"
  ]
};

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const isAuthenticated = useIsAuthenticated();

  return (
      <footer className="slam-footer">
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
        />
        <div className="container footer-container">
          <div className="row g-5">
            
            {/* Column 1: Brand & Identity */}
            <div className="col-lg-4">
              <div className="footer-brand">
                <Link to="/">
                  <img src={logoLight} alt="SLAMMMM" />
                </Link>
                <p className="brand-desc">
                  Building the next generation of authentic connections. 
                  Where your vibe meets your tribe. Join the social evolution.
                </p>
                <div className="social-wrap">
                  <a href="https://www.instagram.com/slammmm_com/" target="_blank" rel="nofollow noreferrer" className="social-circle"><i className="fa-brands fa-instagram"></i></a>
                  <a href="https://www.facebook.com/p/Slammmmcom-100063651783076/" target="_blank" rel="nofollow noreferrer" className="social-circle"><i className="fa-brands fa-facebook-f"></i></a>
                </div>
              </div>
            </div>

            {/* Column 2: Navigation Links */}
            <div className="col-lg-4">
              <div className="row">
                <div className="col-6">
                  <h6 className="nav-title">Navigation</h6>
                  <ul className="nav-list">
                    <li><Link to="/mission" className="nav-link">Our Story</Link></li>
                    <li><Link to="/features" className="nav-link">Features</Link></li>
                    <li><Link to="/blogs" className="nav-link">Journal</Link></li>
                    <li><Link to="/contact-dating-agency" className="nav-link">Get in Touch</Link></li>
                  </ul>
                </div>
                <div className="col-6">
                  <h6 className="nav-title">Support</h6>
                  <ul className="nav-list">
                    <li><Link to="/help" className="nav-link">Help Center</Link></li>
                    <li><Link to="/faq" className="nav-link">FAQs</Link></li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Column 3: Premium CTA Card */}
            <div className="col-lg-4">
              <div className="footer-cta-card">
                <h4 className="cta-title">
                  {isAuthenticated ? "Welcome Back" : "Ready to start?"}
                </h4>
                <p style={{ color: "rgb(146 164 190)", fontSize: '14px', marginBottom: '25px', lineHeight: '1.6' }}>
                  {isAuthenticated 
                    ? "Head over to your dashboard to see your new connections." 
                    : "Join 10,000+ people finding their authentic tribe today."}
                </p>
                
                {isAuthenticated ? (
                  <Link to="/dashboard" className="footer-btn-premium">
                    Go to Dashboard <i className="fa-solid fa-gauge-high"></i>
                  </Link>
                ) : (
                  <>
                    <Link to="/signup" className="footer-btn-premium">
                      Get Started <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                    <p className="login-prompt">
                      Already have an account? 
                      <Link to="/login" className="login-link">Log in</Link>
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="footer-divider"></div>

          {/* Bottom Bar */}
          <div className="row align-items-center">
            <div className="col-md-6 text-md-start text-center">
              <p className="copyright mb-0" style={{ fontSize: '13px', color: 'rgb(145 160 183)' }}>
                © {currentYear} <span className="highlight-text" style={{ color: '#fff' }}>SLAMMMM</span>. All rights reserved.
                {' '}Powered by <a href="https://webandadssolution.com/" target="_blank" rel="noreferrer" style={{ color: 'rgb(145 160 183)' }}>Web and Ads Solution</a>
              </p>
            </div>
            <div className="col-md-6 text-md-end text-center">
              <div className="legal-wrap">
                <Link to="/terms" className="legal-link">Terms</Link>
                <Link to="/privacy-policy" className="legal-link">Privacy</Link>
                <Link to="/cookies" className="legal-link">Cookies</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
  );
};

export default Footer;